import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import RadioButton from 'LuxKit/Radio/RadioButton'
import clsx from 'clsx'
import Colour from 'components/utils/Colour'
import noop from 'lib/function/noop'
import { rem } from 'polished'
import { useCallback } from 'react'
import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

const IndentableListItem = styled(ClickableListItem)`
  &.indented {
    padding-left: ${rem(52)};
  }
`

interface Props {
  airport: App.AirportLocation
  onClick?: (airport: App.AirportLocation) => void
  selected?: boolean
  indented?: boolean
  withRadioButton?: boolean
}

function OfferAirportSelectOption(props: Props) {
  const intl = useIntl()
  const { airport, onClick = noop, selected, indented = false, withRadioButton = false, ...rest } = props
  const onAirportSelect = useCallback(() => {
    onClick(airport)
  }, [airport, onClick])

  let title: React.ReactNode = <>{airport.airportName} <Colour value="light-foreground-alt">{airport.airportCode}</Colour></>
  if (airport.isMultiAirport) {
    const splitName = (/^(.+) all airports$/i).exec(airport.airportName)
    const cityName = splitName?.[1] ?? airport.cityDesc
    if (cityName) {
      title = <FormattedMessage
        id="B7nJUHuHbhrNERi2tuHJ"
        defaultMessage="{cityName} <muted>All airports</muted>"
        description="Airport option title showing city name with all airports indicator"
        values={{
          cityName,
          muted: (chunks) => <Colour value="light-foreground-alt">{chunks}</Colour>,
        }}
      />
    } else {
      title = airport.airportName
    }
  }

  const subtitle = airport.cityDesc && airport.country
    ? intl.formatMessage(
        {
          id: 'lKZVD6TaZuq9E4SUNKpY',
          defaultMessage: '{cityDesc}, {country}',
          description: 'Airport select option city and country separated by comma',
        },
        { cityDesc: airport.cityDesc, country: airport.country },
      )
    : (airport.cityDesc || airport.country || undefined)

  return <IndentableListItem
    {...rest}
    className={clsx({ indented })}
    size="large"
    startIcon={withRadioButton ? <RadioButton checked={selected} /> : <LinePlaneDepartureIcon />}
    title={title}
    subtitle={<Colour value="light-foreground-alt">{subtitle}</Colour>}
    onClick={onAirportSelect}
    selected={selected}
  />
}

export default OfferAirportSelectOption
